import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faSquare } from '@fortawesome/pro-light-svg-icons';
import { faSquareCheck } from '@fortawesome/pro-light-svg-icons';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import { faCircleSmall } from '@fortawesome/pro-solid-svg-icons';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

import 'components/desktop/_general/Input/TreeInput/TreeInput.scss';
import * as StringList from 'types/Product/Search/StringList';
import * as Tree from 'types/_general/Tree/Tree';
import * as TreeList from 'types/_general/Tree/TreeList';

const treeMarginLeft: number = 20;
const selectionColor: string = '#6699cc';
const highlightColor: string = '#dc3545';

interface IProps {
	input: Tree.Type[];
	searchTerm: string;
	setSelected: (input: Tree.Type[]) => void;
	selected: Tree.Type[];
	noObjectsFoundText?: string;
}

const TreeComponent = (props: IProps) => {
	const [opened, setOpened] = useState<string[]>([]);

	const renderOpenClosedIcon = (tree: Tree.Type, searchTerm: string): JSX.Element => {
		if (!tree.children.length)
			return (
				<span style={{ width: '15px', display: 'inline-block', color: '#ddd' }}>
					<FontAwesomeIcon icon={faCircleSmall as IconProp} size="xs" />
				</span>
			);
		return (
			<span
				onClick={() => setOpened(StringList.addOrRemove(opened, tree.id))}
				style={{
					width: '15px',
					display: 'inline-block',
					color: Tree.isUnClosebale(tree, searchTerm) ? highlightColor : undefined,
					cursor: Tree.isUnClosebale(tree, searchTerm) ? 'not-allowed' : undefined,
				}}
			>
				{Tree.isOpened(tree, searchTerm, opened) &&
				Tree.subTreeContainsSearchTerm(tree, searchTerm) ? (
					<FontAwesomeIcon icon={faCaretDown as IconProp} />
				) : (
					<FontAwesomeIcon icon={faCaretRight as IconProp} />
				)}
			</span>
		);
	};

	const renderSelectionIcon = (id: string): JSX.Element => {
		return (
			<span
				style={{
					marginRight: '5px',
					color: TreeList.isSelected(props.selected, id) ? selectionColor : 'grey',
				}}
			>
				{TreeList.isSelected(props.selected, id) ? (
					<FontAwesomeIcon icon={faSquareCheck as IconProp} />
				) : (
					<FontAwesomeIcon icon={faSquare as IconProp} />
				)}
			</span>
		);
	};

	const renderName = (tree: Tree.Type, searchTerm: string): JSX.Element => {
		const { name, id } = tree;
		const index: number = name.toLowerCase().indexOf(searchTerm.toLowerCase());
		if (index !== -1) {
			const textBefore: string = name.slice(0, index);
			const textHighlight: string = name.slice(index, index + searchTerm.length);
			const textAfter: string = name.slice(index + searchTerm.length);
			return (
				<span
					style={{
						color: TreeList.isSelected(props.selected, id) ? selectionColor : undefined,
					}}
				>
					{textBefore}
					<span style={{ color: highlightColor }}>{textHighlight}</span>
					{textAfter}
				</span>
			);
		}
		return (
			<span
				style={{
					color: TreeList.isSelected(props.selected, id) ? selectionColor : undefined,
				}}
			>
				{name}
			</span>
		);
	};

	const renderTreeItem = (
		treeArray: Tree.Type[],
		level: number,
		searchTerm: string
	): JSX.Element => {
		return (
			<>
				{treeArray.map((tree: Tree.Type, i: number) => {
					if (Tree.isOpened(tree, searchTerm, opened) || searchTerm === '') {
						return (
							<div
								key={`${i}-${level}`}
								style={{ marginLeft: level ? `${treeMarginLeft}px` : undefined }}
							>
								{renderOpenClosedIcon(tree, searchTerm)}
								<span
									onClick={() =>
										props.setSelected(
											TreeList.addOrRemove(props.selected, tree)
										)
									}
									style={{ cursor: 'pointer' }}
								>
									{renderSelectionIcon(tree.id)}
									{renderName(tree, searchTerm)}
								</span>
								{Tree.isOpened(tree, searchTerm, opened) ? (
									renderTreeItem(tree.children, level + 1, searchTerm)
								) : (
									<></>
								)}
							</div>
						);
					}
				})}
			</>
		);
	};

	if (TreeList.getTreeForRendering(props.input, props.searchTerm).length) {
		return renderTreeItem(
			TreeList.getTreeForRendering(props.input, props.searchTerm),
			0,
			props.searchTerm
		);
	}
	return <div style={{ color: 'grey' }}>{props.noObjectsFoundText ?? '–'}</div>;
};

export default TreeComponent;
